<script lang="ts">
    import {onMount} from "svelte";
    import {type AdminSummary, authorized_admins} from "@shared/Types.ts";
    import {email, fetchOrigin, page} from "../data.ts";
    import {sleep} from "@shared/Utils.ts";

    let summary: AdminSummary;
    let msg = '';

    async function load() {
        if (!authorized_admins.includes($email)) {
            page.set('EnterEmail');
        }
        const result = await fetchOrigin(`/admin-summary`);
        summary = await result.json();
    }

    onMount(load)
</script>


<article>
    <h3>Admin Page</h3>
    <p>Welcome to the Admin Page.</p>

    {#if msg}
        <div class="alert alert-warning">{msg}</div>
    {/if}

    {#if summary}
        <p>{summary.registrationCount} users have started a registration.</p>

        <p>{summary.registrations.inProgress}/{summary.registrations.max} attendees under in progress or completed registrations</p>
        <progress value={summary.registrations.inProgress} max={summary.registrations.max} />
        <p>{summary.registrations.completed}/{summary.registrations.max} of attendees under completed registrations</p>
        <progress value={summary.registrations.completed} max={summary.registrations.max} />
        <p>The following attendees are owed a refund:</p>
        <ul>
            {#each summary.owedRefund ?? [] as owed}
                <li>{owed}</li>
            {:else}
                <li>No attendees are owed a refund</li>
            {/each}
        </ul>
    {/if}

    <a href="/export">Click here to download the registrations.</a>
</article>
<article>
    <h3>Authorized Users</h3>
    <p>Only the following authorized users are permitted to see this page:</p>
    <ul>
        {#each authorized_admins as admin}
            <li>{admin}</li>
        {:else}
            <li>No authorized admins</li>
        {/each}
    </ul>
    <p>To add an additional user, please contact Forrest at forrestmilner@gmail.com</p>
</article>
